import { useUser } from "@auth0/nextjs-auth0/client";
import { ReportContext } from "contexts/reportContext";
import React, { useContext, useEffect, type ReactNode } from "react";

export default function Layout({ children }: { children: ReactNode }) {
  const { user } = useUser();
  const { setUploads } = useContext(ReportContext);

  useEffect(() => {
    if (user) {
      fetch("api/uploads")
        .then((res) => res.json())
        .then(({ uploads }) => {
          setUploads(uploads);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    // if ("serviceWorker" in navigator) {
    //   navigator.serviceWorker
    //     .register("/service-worker.js")
    //     .then((registration) => {
    //       console.log("scope is: ", registration.scope);
    //     })
    //     .catch((err) => {
    //       console.error("service worker registration failed", err.message);
    //     });
    // }
  }, [user]);

  return <main style={{ height: "100%" }}>{children}</main>;
}
